import React from "react";
import { connect } from "react-redux";
import AstrologyDetail from "../../../../Profile/Home/ProfileInformation/Astrology/AstrologyDetail";
import getMemberAstrologyProfile from "../../../../../_selectors/profileSelectors/getMemberAstrologyProfile";

const Astrology = ({ userProfile, showToast }) => {
  return <AstrologyDetail userProfile={userProfile} showEdit={false} />;
};

const mapStateToProps = (state, ownProps) => ({
  userProfile: getMemberAstrologyProfile(state)
});

export default connect(mapStateToProps)(Astrology);



// WEBPACK FOOTER //
// ./src/_components/ViewProfile/Profile/ProfileInformation/Astrology/index.js